/**
 * Maps a sidebar item title to a Feather icon name. Used by SidebarContent
 * to give every nav item — including sub-items that didn't ship with an
 * explicit `icon` — a visual anchor. First match wins; falls back to a
 * neutral "circle".
 */

const HINTS = [
  // dashboards / overviews
  [/^dashboard$/i, "grid"],
  [/overview/i, "grid"],

  // requests / tickets / maintenance
  [/all requests|view requests|view maintenance requests/i, "inbox"],
  [/create request/i, "plus-circle"],
  [/maintenance requests|requests$/i, "tool"],
  [/maintenance team|team members|maintenance$/i, "users"],
  [/request types/i, "list"],
  [/entry permissions|permissions/i, "key"],
  [/email notifications/i, "mail"],

  // categories / specialities / tags
  [/add category|categories|category|specialit/i, "tag"],

  // inventory / orders / facility
  [/orders/i, "shopping-bag"],
  [/facility items/i, "box"],
  [/manage inventory|inventory/i, "package"],
  [/rm vendors/i, "truck"],

  // building / inspections
  [/building inspections/i, "clipboard"],
  [/suite inspections/i, "home"],
  [/move.?in|move.?out/i, "log-in"],
  [/incident reports?/i, "alert-triangle"],
  [/inspections tracker|tracker/i, "activity"],
  [/vendor inspection report/i, "file-text"],
  [/snow|ice|weather/i, "cloud-snow"],
  [/building operations|building$/i, "home"],

  // mastersheet
  [/active mastersheet/i, "database"],
  [/archived mastersheet|archive/i, "archive"],
  [/color configuration/i, "droplet"],
  [/property fields/i, "sliders"],
  [/mastersheet/i, "database"],

  // properties / managers / accountants
  [/all properties|properties$/i, "home"],
  [/property layout/i, "layout"],
  [/property managers/i, "user-check"],
  [/accountants?/i, "dollar-sign"],

  // calendar / appointments / availability
  [/activity calendar|calendar view|calendar$/i, "calendar"],
  [/approve appointments|appointments?/i, "check-square"],
  [/availability|set availability slots/i, "clock"],
  [/reason types?/i, "help-circle"],
  [/status types?|status$/i, "activity"],

  // sales / applications / leads
  [/applications?/i, "file-text"],
  [/view leads/i, "trending-up"],
  [/rdcare leads|leads/i, "trending-up"],
  [/assistant leads/i, "message-square"],
  [/sales operations|sales$/i, "shopping-cart"],

  // parking / storage
  [/assign parking|parking/i, "square"],
  [/assign storage|storage/i, "hard-drive"],

  // statements / approvers / auditors
  [/view all soas|statements? of account|generate.?soa/i, "file"],
  [/approvers?/i, "check-circle"],
  [/auditors?/i, "shield"],

  // vendors
  [/approve vendors/i, "check-circle"],
  [/contractors? mastersheet|contractors?/i, "briefcase"],
  [/vendor categories/i, "tag"],
  [/vendors? preview|view vendors|vendors$/i, "users"],

  // reports / kpi
  [/kpi report|kpi/i, "bar-chart-2"],
  [/upload kpi|upload/i, "upload"],
  [/cs report card/i, "user"],
  [/community leader report/i, "award"],
  [/r&m report card|r and m/i, "bar-chart-2"],
  [/report cards|reports$/i, "bar-chart-2"],

  // ops / settings
  [/apps & integrations|apps$/i, "cpu"],
  [/company knowledge base|knowledge/i, "book"],
  [/chatbot|chat bot|chat/i, "message-circle"],
  [/voice assistant|voice/i, "mic"],
  [/settings/i, "settings"],
  [/other operations|operations$/i, "layers"],

  // companies (admin)
  [/companies/i, "briefcase"],
  [/blogs?|blog list|add blogs|edit blog/i, "edit-3"],
  [/newsletters?/i, "send"],
  [/vendor speciality|vendor categor/i, "tag"],

  // generic verbs
  [/add|new|create/i, "plus-circle"],
  [/view|preview/i, "eye"],
  [/edit|update/i, "edit-2"],
];

const sidebarIconFor = (title) => {
  if (!title) return "circle";
  for (const [pattern, icon] of HINTS) {
    if (pattern.test(title)) return icon;
  }
  return "circle";
};

export default sidebarIconFor;
